(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/list.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/cart/components/list.js');
"use strict";


const Hr = svs.tickets_giftshop.components.HR;
const {
  Item,
  Empty
} = svs.tickets_giftshop.gift.giftform.cart.components;
const {
  SET,
  APPEND
} = svs.tickets_giftshop.constants.cart;
const {
  getCart
} = svs.tickets_giftshop.gift.giftform.cart.getters;
const List = _ref => {
  let {
    cart = []
  } = _ref;
  return React.createElement("div", {
    className: "tg-cart-list"
  }, cart.length ? cart.map(_ref2 => {
    let {
      amount,
      product,
      isAnimatingOnRender,
      lastUpdatedFromType
    } = _ref2;
    const {
      productId,
      productVariation,
      type,
      skinId
    } = product;
    return React.createElement(React.Fragment, {
      key: "tg-cart-item-".concat(productId, "_").concat(productVariation, "_").concat(type, "_").concat(skinId)
    }, React.createElement(Item, {
      amount: amount,
      isAnimatingOnRender: isAnimatingOnRender,
      lastUpdatedFromType: lastUpdatedFromType,
      product: product
    }), React.createElement(Hr, null));
  }) : React.createElement(Empty, null));
};
const mapStateToProps = state => {
  const {
    cart,
    error
  } = getCart(state);
  return {
    cart,
    error
  };
};
svs.tickets_giftshop.gift.giftform.cart.components.List = ReactRedux.connect(mapStateToProps)(List);

 })(window);